<template>
  <div class="sms-biz-message-push-detail">
    <AppScrollbar style="height: 100%">
      <div class="detail-main">
        <el-form size="mini"
                 label-width="72px"
                 label-suffix="：">
          <el-form-item label="手机号">
            <div class="value">{{detailInfo.mobilePhone}}</div>
          </el-form-item>
          <el-form-item label="消息内容">
            <div class="content">{{detailInfo.content}}</div>
          </el-form-item>
          <el-form-item v-if="detailInfo.sendState"
                        label="发送状态">
            <div class="value">
              <el-tag size="mini"
                      :type="detailInfo.sendState.code | sendState">{{detailInfo.sendState.name}}</el-tag>
            </div>
          </el-form-item>
          <el-form-item v-if="detailInfo.sendDate"
                        label="发送时间">
            <div class="value">{{detailInfo.sendDate}}</div>
          </el-form-item>
          <el-form-item v-if="detailInfo.smsId"
                        label="消息ID">
            <div class="value">{{detailInfo.smsId}}</div>
          </el-form-item>
        </el-form>
      </div>
    </AppScrollbar>
  </div>
</template>

<script>
import AppScrollbar from '../../../../../../../../../elements/AppScrollbar'
export default {
  name: 'SmsBizMessagePushDetail',
  components: {
    AppScrollbar
  },
  props: {
    detailInfo: {
      type: Object,
      required: true
    }
  },
  filters: {
    sendState (val) {
      if (val === '1') {
        return 'success'
      } else {
        return 'danger'
      }
    }
  }
}
</script>

<style lang="scss">
  .sms-biz-message-push-detail {
    height: 100%;
    .detail-main {
      padding: 15px;
      .el-form {
        .el-form-item {
          margin-bottom: 5px;
          .el-form-item__label {
            color: #909399;
            font-size: 12px;
            text-align: left;
          }
          .el-form-item__content {
            font-size: 12px;
            .value,
            .content {
              word-break: break-all;
              word-wrap: break-word;
            }
            .content {
              color: #606266;
              line-height: 200%;
              background-color: #fff;
              border-left: 2px solid #909399;
              padding: 6px 12px;
              white-space: pre-wrap;
            }
          }
        }
      }
    }
  }
</style>
